module.exports = __webpack_public_path__ + "static/media/hero_plane_image.45feef74.jpg";